import { concatLatestFrom } from '@ngrx/operators';
import { select, Store } from '@ngrx/store';
import { map, of, pipe } from 'rxjs';

import { appInject } from 'src/app/app-injector';
import { SettingsService } from 'src/app/core/services/settings/settings.service';
import { FinanceCalculatorEnvironment } from 'src/app/shared/financing/finance-calculator/finance-calculator-environment.enum';
import { firstValueFromSync, fromRouterAsSnapshot } from 'src/app/store/router/next-router.selectors';
import { selectFcisEnvironment } from 'src/app/store/runtime-variables/runtime-variables.selectors';

export const getProvidedOrDefaultFcisEnvironment = (): FinanceCalculatorEnvironment => {
  const settingsService = appInject(SettingsService);
  const store = appInject(Store);

  const fcisEnvironmentFromUrl = firstValueFromSync(
    store.pipe(fromRouterAsSnapshot.selectFcisEnvironmentQueryParam)
  ) as FinanceCalculatorEnvironment;

  const defaultEnvironment = settingsService.data.financialCalculatorEnvironment;

  return fcisEnvironmentFromUrl && Object.values(FinanceCalculatorEnvironment).includes(fcisEnvironmentFromUrl)
    ? fcisEnvironmentFromUrl
    : defaultEnvironment;
};

/**
 * Returns fc environment from
 * - context (when set on doorway page), or
 * - url query parameter (if valid), or
 * - environment settings
 */
export const selectFcEnvironment = pipe(
  select(selectFcisEnvironment),
  concatLatestFrom(() => of(getProvidedOrDefaultFcisEnvironment())),
  map(
    ([fcEnvironmentFromContext, fcEnvironmentDerivedFromCurrentHost]) =>
      fcEnvironmentFromContext || fcEnvironmentDerivedFromCurrentHost
  )
);
